/**
 * @generated SignedSource<<f573d24e7a767ddae9de2944266b0c03>>
 * @relayHash b91bd00d73e80006d2f5e7a836bbc8ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dce093de63bcb8ac01b0bf807bbc31f1f01d049f07ef7861acce97abddbe9b36

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery$variables = {
  amountOfColumns?: number | null | undefined;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsContext?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  filterId?: string | null | undefined;
  isIssueSearchAPIEnabled: boolean;
  isRealtimeUpdateEnabled: boolean;
  issueKey: string;
  issueSearchInput: JiraIssueSearchInput;
  namespace?: string | null | undefined;
  shouldQueryFieldSetsById: boolean;
  viewId?: string | null | undefined;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data">;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery = {
  response: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery$data;
  variables: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery$variables;
};
({
  "isIssueSearchAPIEnabled": isIssueSearchAPIEnabled_provider,
  "isRealtimeUpdateEnabled": isRealtimeUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider": isIssueSearchAPIEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isRealtimeUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
  readonly isIssueSearchAPIEnabled: {
    readonly get: () => boolean;
  };
  readonly isRealtimeUpdateEnabled: {
    readonly get: () => boolean;
  };
});

import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isIssueSearchAPIEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-view-child-issues-panel-issuesearch.relayprovider';
import isRealtimeUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-view-child-issues-panel-realtime-update.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIssueSearchAPIEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRealtimeUpdateEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldSetsById"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v13 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v17 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v18 = {
  "kind": "ScalarField",
  "name": "type"
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v21 = {
  "kind": "ScalarField",
  "name": "__id"
},
v22 = {
  "kind": "ClientExtension",
  "selections": [
    (v21/*: any*/)
  ]
},
v23 = [
  (v15/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "key"
},
v25 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  }
],
v26 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v27 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v28 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v29 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v15/*: any*/)
  ]
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v31 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v32 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v33 = {
  "kind": "ScalarField",
  "name": "name"
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v33/*: any*/),
                (v15/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v35 = {
  "kind": "ScalarField",
  "name": "value"
},
v36 = [
  (v35/*: any*/),
  (v15/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v37 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v38 = {
  "kind": "ClientExtension",
  "selections": [
    (v37/*: any*/)
  ]
},
v39 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v40 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v41 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v42 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v43 = {
  "kind": "ScalarField",
  "name": "text"
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    (v33/*: any*/),
    (v38/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v45 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v15/*: any*/)
  ]
},
v46 = [
  (v45/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v48 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v35/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v50 = {
  "kind": "ScalarField",
  "name": "picture"
},
v51 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v52 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraCascadingOption",
          "kind": "LinkedField",
          "name": "cascadingOption",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "parentOptionValue",
              "plural": false,
              "selections": (v36/*: any*/)
            },
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "childOptionValue",
              "plural": false,
              "selections": (v36/*: any*/)
            }
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraCascadingSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "args": (v39/*: any*/),
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v40/*: any*/),
                    (v41/*: any*/),
                    (v15/*: any*/)
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedComponentsConnection(first:1000)"
        },
        (v38/*: any*/)
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        (v33/*: any*/),
        (v38/*: any*/)
      ],
      "type": "JiraDateTimePickerField"
    },
    (v44/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCommentSummary",
          "kind": "LinkedField",
          "name": "commentSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canAddComment"
            },
            (v20/*: any*/)
          ]
        }
      ],
      "type": "JiraCommentSummaryField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "kind": "ScalarField",
          "name": "uri"
        },
        (v38/*: any*/)
      ],
      "type": "JiraUrlField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "fieldOptions",
          "plural": false,
          "selections": [
            (v20/*: any*/)
          ]
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "fieldOption",
          "plural": false,
          "selections": [
            (v35/*: any*/),
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v46/*: any*/)
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v46/*: any*/)
            },
            (v15/*: any*/),
            (v47/*: any*/)
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraSingleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v35/*: any*/),
                    (v47/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraMultipleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v48/*: any*/)
              ]
            }
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraCheckboxesField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v14/*: any*/),
                    (v49/*: any*/),
                    (v33/*: any*/),
                    (v50/*: any*/),
                    (v15/*: any*/),
                    (v51/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "email"
                        }
                      ],
                      "type": "AtlassianAccountUser"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraMultipleSelectUserPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraTeamView",
          "kind": "LinkedField",
          "name": "selectedTeam",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedId"
            },
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedName"
            }
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraTeamViewField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "concreteType": "JiraEstimate",
                  "kind": "LinkedField",
                  "name": "originalEstimate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "timeInSeconds"
                    }
                  ]
                },
                {
                  "concreteType": "JiraTimeTrackingSettings",
                  "kind": "LinkedField",
                  "name": "timeTrackingSettings",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "workingHoursPerDay"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "workingDaysPerWeek"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultFormat"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultUnit"
                    }
                  ]
                },
                (v27/*: any*/),
                (v33/*: any*/),
                (v18/*: any*/),
                (v38/*: any*/)
              ]
            },
            (v15/*: any*/)
          ]
        }
      ],
      "type": "JiraOriginalTimeEstimateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "selectedOption",
          "plural": false,
          "selections": [
            {
              "alias": "label",
              "kind": "ScalarField",
              "name": "value"
            },
            (v15/*: any*/),
            (v40/*: any*/)
          ]
        },
        (v38/*: any*/)
      ],
      "type": "JiraRadioSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "args": (v39/*: any*/),
          "concreteType": "JiraVersionConnection",
          "kind": "LinkedField",
          "name": "selectedVersionsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraVersionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraVersion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v33/*: any*/),
                    (v40/*: any*/),
                    (v41/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "versionId"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedVersionsConnection(first:1000)"
        },
        (v38/*: any*/)
      ],
      "type": "JiraMultipleVersionPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": (v23/*: any*/)
        },
        {
          "args": (v39/*: any*/),
          "concreteType": "JiraGoalConnection",
          "kind": "LinkedField",
          "name": "selectedGoals",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v24/*: any*/)
                  ]
                }
              ]
            },
            (v22/*: any*/)
          ],
          "storageKey": "selectedGoals(first:1000)"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            (v21/*: any*/),
            (v37/*: any*/)
          ]
        }
      ],
      "type": "JiraGoalsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        {
          "args": (v39/*: any*/),
          "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
          "kind": "LinkedField",
          "name": "confluenceRemoteIssueLinks",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraConfluenceRemoteIssueLink",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "href"
                    }
                  ]
                }
              ]
            },
            (v20/*: any*/)
          ],
          "storageKey": "confluenceRemoteIssueLinks(first:1000)"
        },
        (v38/*: any*/)
      ],
      "type": "JiraConfluenceRemoteIssueLinksField"
    }
  ]
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v54 = [
  (v33/*: any*/),
  (v15/*: any*/)
],
v55 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "componentsOld",
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v54/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/)
      ],
      "type": "JiraSingleLineTextField"
    }
  ]
},
v56 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "date"
    },
    (v33/*: any*/),
    (v56/*: any*/),
    (v38/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        {
          "kind": "ScalarField",
          "name": "summary"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        (v28/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v29/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v33/*: any*/)
              ]
            }
          ]
        },
        (v20/*: any*/)
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v33/*: any*/),
    (v38/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        },
        (v33/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v65 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v15/*: any*/)
  ]
},
v66 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v15/*: any*/)
  ]
},
v67 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v68 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v67/*: any*/),
        (v33/*: any*/),
        (v15/*: any*/)
      ]
    },
    (v15/*: any*/)
  ]
},
v69 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        (v65/*: any*/),
        (v15/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v24/*: any*/),
            (v66/*: any*/),
            (v68/*: any*/),
            (v65/*: any*/),
            (v15/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v24/*: any*/),
            (v66/*: any*/),
            (v68/*: any*/),
            (v65/*: any*/),
            (v15/*: any*/),
            (v26/*: any*/),
            (v69/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "summary",
                    "issuetype",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v14/*: any*/),
                        (v15/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v27/*: any*/),
                            (v43/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v27/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "issueTypeId"
                                },
                                (v33/*: any*/),
                                (v67/*: any*/),
                                (v31/*: any*/),
                                (v15/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        (v30/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
            }
          ]
        },
        (v33/*: any*/),
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraParentIssueField"
},
v71 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        (v15/*: any*/)
      ]
    },
    (v33/*: any*/),
    (v38/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        (v24/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v54/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v33/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ]
        }
      ]
    },
    (v33/*: any*/),
    (v38/*: any*/)
  ],
  "type": "JiraSprintField"
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v49/*: any*/),
        (v50/*: any*/),
        (v33/*: any*/),
        (v15/*: any*/),
        (v51/*: any*/)
      ]
    },
    (v33/*: any*/),
    (v56/*: any*/),
    (v38/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    {
      "args": (v39/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v54/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    }
  ],
  "type": "JiraMultipleVersionPickerField"
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        (v67/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v69/*: any*/),
                    (v24/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v14/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v29/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v15/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    (v15/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v15/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v80 = {
  "kind": "ScalarField",
  "name": "number"
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v80/*: any*/),
    (v33/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        (v80/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v80/*: any*/),
        (v33/*: any*/),
        (v38/*: any*/)
      ]
    },
    (v38/*: any*/)
  ],
  "type": "JiraNumberField"
},
v82 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v17/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v27/*: any*/),
                      (v18/*: any*/),
                      (v32/*: any*/),
                      (v15/*: any*/),
                      (v34/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v44/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v73/*: any*/),
                      (v74/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/),
                      (v77/*: any*/),
                      (v78/*: any*/),
                      (v79/*: any*/),
                      (v81/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v83 = [
  {
    "kind": "ScalarField",
    "name": "cursor"
  },
  {
    "kind": "ScalarField",
    "name": "pageNumber"
  },
  {
    "kind": "ScalarField",
    "name": "isCurrent"
  }
],
v84 = [
  (v20/*: any*/),
  {
    "concreteType": "JiraIssueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v24/*: any*/),
          (v26/*: any*/),
          (v15/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isResolved"
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "ids",
                "value": [
                  "status"
                ]
              }
            ],
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fieldsById",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v30/*: any*/),
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "fieldsById(ids:[\"status\"])"
          },
          {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v15/*: any*/)
                ]
              },
              (v15/*: any*/)
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              (v21/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                      },
                      (v16/*: any*/)
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": (v82/*: any*/)
                  }
                ]
              },
              {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "context",
                        "variableName": "fieldSetsContext"
                      },
                      {
                        "kind": "Variable",
                        "name": "filterId",
                        "variableName": "filterId"
                      },
                      (v16/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "namespace",
                        "variableName": "namespace"
                      },
                      {
                        "kind": "Variable",
                        "name": "viewId",
                        "variableName": "viewId"
                      }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": (v82/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      },
      (v14/*: any*/),
      (v22/*: any*/),
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 500
              }
            ],
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v17/*: any*/),
                      {
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v27/*: any*/),
                                  (v18/*: any*/),
                                  (v32/*: any*/),
                                  (v15/*: any*/),
                                  (v34/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v55/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v44/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v70/*: any*/),
                                  (v71/*: any*/),
                                  (v72/*: any*/),
                                  (v73/*: any*/),
                                  (v74/*: any*/),
                                  (v75/*: any*/),
                                  (v76/*: any*/),
                                  (v77/*: any*/),
                                  (v78/*: any*/),
                                  (v79/*: any*/),
                                  (v81/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedOptions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              (v48/*: any*/),
                                              (v22/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraCheckboxesField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "fieldOption",
                                        "plural": false,
                                        "selections": [
                                          (v47/*: any*/),
                                          (v15/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraSingleSelectField"
                                  },
                                  (v22/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": "fieldSets(first:500)"
          }
        ]
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "jql"
  },
  {
    "kind": "ScalarField",
    "name": "totalIssueSearchResultCount"
  },
  {
    "kind": "ScalarField",
    "name": "isCappingIssueSearchResult"
  },
  {
    "concreteType": "JiraIssueNavigatorPageInfo",
    "kind": "LinkedField",
    "name": "issueNavigatorPageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "firstIssuePosition"
      },
      {
        "kind": "ScalarField",
        "name": "lastIssuePosition"
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "maxCursors",
        "value": 7
      }
    ],
    "concreteType": "JiraPageCursors",
    "kind": "LinkedField",
    "name": "pageCursors",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "first",
        "plural": false,
        "selections": (v83/*: any*/)
      },
      {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "around",
        "plural": true,
        "selections": (v83/*: any*/)
      },
      {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "last",
        "plural": false,
        "selections": (v83/*: any*/)
      }
    ],
    "storageKey": "pageCursors(maxCursors:7)"
  },
  {
    "kind": "LinkedField",
    "name": "issueSearchError",
    "plural": false,
    "selections": [
      (v14/*: any*/)
    ]
  },
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v13/*: any*/),
              {
                "kind": "Variable",
                "name": "issueKey",
                "variableName": "issueKey"
              }
            ],
            "kind": "LinkedField",
            "name": "fieldSetViewQueryByProject",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hasDefaultFieldSets"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "fieldSetSelectedState": "SELECTED"
                        }
                      },
                      (v16/*: any*/)
                    ],
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isSortable"
                              },
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "width"
                                  }
                                ]
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isPlaceHolderField"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldType",
                                "kind": "LinkedField",
                                "name": "fieldType",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v20/*: any*/),
                      (v22/*: any*/)
                    ]
                  }
                ],
                "type": "JiraFieldSetView"
              },
              {
                "kind": "InlineFragment",
                "selections": (v23/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "editIssues",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "EDIT_ISSUES"
                                  }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                  }
                                ],
                                "storageKey": "action(type:\"EDIT_ISSUES\")"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          (v24/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      (v15/*: any*/)
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v25/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": (v84/*: any*/)
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v25/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearchStable",
                "plural": false,
                "selections": (v84/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dce093de63bcb8ac01b0bf807bbc31f1f01d049f07ef7861acce97abddbe9b36",
    "metadata": {},
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "isIssueSearchAPIEnabled": isIssueSearchAPIEnabled_provider,
      "isRealtimeUpdateEnabled": isRealtimeUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider": isIssueSearchAPIEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isRealtimeUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "5bf7ffd6cf0143b9a91349618ba8b07f";

export default node;
